import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { ZxcvbnLoad } from '../../zxcvbn-load';

@Component({
  selector: 'password-score',
  templateUrl: './password-score.component.html',
  styleUrls: ['./password-score.component.css'],
})
export class PasswordScoreComponent implements OnInit, OnChanges {
  @Input()
  password: string = '';

  strength: number = 0;
  color: string;
  label: string;

  private zxcvbn;

  constructor() {}

  ngOnInit() {
    ZxcvbnLoad.asyncLoad().then((zxcvbn) => {
      this.zxcvbn = zxcvbn;
      this.getStrength(this.password);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['password'];
    if (change) {
      this.getStrength(change.currentValue);
    }
  }

  getStrength(password) {
    if (this.zxcvbn) {
      const estimation = this.zxcvbn(password || '');
      this.strength = (estimation.score / 4) * 100;
      switch (estimation.score) {
        case 0:
          this.color = '#FF0000';
          this.label = 'very low';
          break;
        case 1:
          this.color = '#FF410B';
          this.label = 'low';
          break;
        case 2:
          this.color = '#FF7E00';
          this.label = 'medium';
          break;
        case 3:
          this.color = '#C7FF00';
          this.label = 'high';
          break;
        case 4:
          this.color = '#00FF1B';
          this.label = 'very high';
          break;
      }
    }
  }
}
